import { Stack, Typography } from "@mui/material";
import { SegmentBlurbSection } from "../Stores/AcxTranscriptionStore";
import { durationDisplay } from "components/SoundClipEditor/Controls/Player";

function SegmentHeader({ section }: { section: SegmentBlurbSection }) {
    const startTimestamp = section.startTimestamp;
    const endTimestamp = section.endTimestamp;
    const durationSeconds = endTimestamp - startTimestamp;
    const durationLabel =
        durationSeconds < 45
            ? "<1 min"
            : `${Math.round(durationSeconds / 60)} min`;

    return (
        <Stack
            direction="row"
            sx={{ p: 1.5, userSelect: "none", alignItems: "center" }}
        >
            <Typography
                sx={{ fontWeight: 700, fontSize: 14, color: "text.primary" }}
            >
                {section.segment.heading}
            </Typography>
            <Typography
                sx={{
                    color: "gray.500",
                    fontSize: 12,
                    ml: 1,
                }}
            >
                {durationLabel} | From {durationDisplay(startTimestamp)}
            </Typography>
        </Stack>
    );
}

export default SegmentHeader;
